import { MY_OFFER_PRODUCTS_TYPES } from "../types/myOfferProductsTypes";

export const createOfferProductAction = (data, id = "") => {
  return {
    type: MY_OFFER_PRODUCTS_TYPES.CREATE_OFFER_PRODUCT,
    data,
    id,
  };
};
export const getOfferProductsAction = (page = 1, limit = 10) => {
  return {
    type: MY_OFFER_PRODUCTS_TYPES.GET_OFFER_PRODUCTS_LIST,
    page,
    limit,
  };
};

export const getOfferProductsActionForExporter = (page = 1, limit = 10) => {
  return {
    type: MY_OFFER_PRODUCTS_TYPES.GET_OFFER_PRODUCTS_LIST_EXPORTER,
    page,
    limit,
  }
}

  export const deleteOfferProductAction = (id) => {
    return {
      type: MY_OFFER_PRODUCTS_TYPES.DELETE_MY_OFFER_PRODUCT,
      id,
    };
  };

  export const getOfferProductsById = (id) => {
    return {
      type: MY_OFFER_PRODUCTS_TYPES.GET_OFFER_PRODUCT_BY_ID,
      id,
    };
  };